<template>
  <v-container style="max-width: 800px">
    <div style="text-align: left">
      <v-tooltip top v-if="userPermissions['DELETE_ROUNDS_INVITATIONS']">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :disabled="selected.length > 0 ? false : true"
            icon
            @click="deleteInvitation()"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon :color="selected.length > 0 ? 'primary' : 'grey'">
              delete
            </v-icon>
          </v-btn>
        </template>

        <span>Eliminar alumno</span>
      </v-tooltip>
    </div>
    <v-layout>
      <v-container class="table-full">
        <v-layout row wrap>
          <v-flex ma-1 class="expandableContainer" style="overflow: hidden">
            <v-data-table
              v-model="selected"
              select-all
              :headers="headers"
              :items="invitations"
              hide-actions
              ref="table"
              item-key="id"
              no-data-text="No tiene invitaciones"
              :height="'14vh'"
              style="max-height: 18vh; overflow-y: scroll"
            >
              <template v-slot:headers="props">
                <tr>
                  <th
                    v-if="userPermissions['DELETE_ROUNDS_INVITATIONS']"
                    style="width: 50px; max-width: 50px; min-width: 50px"
                  >
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      color="primary"
                      hide-details
                      @click.stop="toggleAll"
                    ></v-checkbox>
                  </th>
                  <th style="width: 50px; max-width: 50px; min-width: 50px">
                    Foto
                  </th>
                  <th style="width: 100%">Nombre</th>
                  <th style="width: 100%">Apellidos</th>
                  <th style="width: 180px; max-width: 180px; min-width: 180px">
                    Estado
                  </th>
                </tr>
                <!-- <th v-for="header in props.headers" style="width: 180px; max-width: 180px; min-width: 180px;" :key="header.text">{{ header.text }}</th> -->
              </template>
              <template v-slot:items="props">
                <td
                  v-if="userPermissions['DELETE_ROUNDS_INVITATIONS']"
                  style="width: 50px; max-width: 50px; min-width: 50px"
                >
                  <v-checkbox
                    color="primary"
                    v-model="props.selected"
                    primary
                    hide-details
                  ></v-checkbox>
                </td>
                <td style="width: 50px; max-width: 50px; min-width: 50px">
                  <v-avatar size="30px">
                    <v-avatar
                      size="30px"
                      color="grey lighten-4"
                      v-if="
                        props.item.student.imageStorage &&
                        props.item.student.imageStorage.miniObjUrl
                      "
                    >
                      <img
                        ref="image"
                        :src="props.item.student.imageStorage.miniObjUrl"
                        alt="avatar"
                      />
                    </v-avatar>
                    <v-icon
                      v-else
                      :color="
                        props.item.student.gender == 'MALE' ? 'blue' : 'pink'
                      "
                      >account_circle</v-icon
                    >
                  </v-avatar>
                </td>
                <td style="width: 100%">{{ props.item.student.firstName }}</td>
                <td style="width: 100%">{{ props.item.student.lastName }}</td>
                <td style="width: 180px; max-width: 180px; min-width: 180px">
                  <v-chip>
                    <v-avatar>
                      <v-icon class="green--text" v-if="props.item.confirm"
                        >check</v-icon
                      >
                      <v-icon class="red--text" v-else>clear</v-icon>
                    </v-avatar>
                    <span v-if="props.item.confirm">Autorizado</span>
                    <span v-else>Pendiente</span>
                  </v-chip>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
      <desition
        @desition="$event ? onDeleteInvitation() : ''"
        v-model="modals.confirmDelete"
        title="Eliminar invitado"
        :description="
          selected.length == 1
            ? msgDeleteInvitationOne
            : msgDeleteInvitationSome
        "
      />
    </v-layout>
  </v-container>
</template>

<script>
import desition from '../../Dialogs/Confirm'

export default {
  props: ['invitations', 'round', 'userPermissions'],
  components: {
    desition,
  },
  data: () => ({
    msgDeleteInvitationOne:
      'Esta acción es irreversible, ¿deseas continuar con la eliminación del alumno de la ronda?',
    msgDeleteInvitationSome:
      'Esta acción es irreversible, ¿deseas continuar con la eliminación de los alumnos de la ronda?',
    idsInvitattions: null,
    invitation: null,
    selected: [],
    modals: {
      confirmDelete: false,
    },
    headers: [
      {
        text: 'Foto',
        align: 'center',
        sortable: false,
        value: 'photo',
      },
      {
        text: 'Nombre',
        align: 'center',
        sortable: false,
        value: 'firstName',
      },
      {
        text: 'Apellidos',
        align: 'center',
        sortable: false,
        value: 'lastName',
      },
      {
        text: 'Estado',
        align: 'center',
        sortable: false,
        value: 'confirm',
      },
    ],
  }),
  methods: {
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.$refs.table.filteredItems.slice()
    },
    deleteInvitation() {
      // this.invitation = invitation
      this.modals.confirmDelete = true
    },
    onDeleteInvitation() {
      // console.log(this.invitation.id)
      let enviar = {}
      enviar.invitationIds = this.filterIdsInvitations
      this.$store
        .dispatch('round/deleteInvitation', {
          idRound: this.round.id,
          enviar,
        })
        .then((response) => {
          console.log('data', response)
          this.$emit('onDelete', 'hola desde hijo')
          this.selected = []
        })
        .catch((e) => {
          console.log(e)
        })
    },
  },
  computed: {
    filterIdsInvitations() {
      return (this.idsInvitattions = this.selected.map((round) => {
        return round.id
      }))
    },
  },
}
</script>

<style scoped>
::v-deep .table-full .v-datatable.v-table > tbody {
  max-height: initial !important;
  min-height: initial !important;
}
/* td,
th {
  width: 421px;
  max-width: 421px;
  min-width: 421px;
} */
.expandableCon {
  border: 1px solid red !important;
  width: 300px;
}
</style>
